/****************************************
 *     配置编译环境和线上环境之间的切换     *
 ****************************************/

let baseUrl = "https://cgweb.testappbeta.com";
let paypalUrl = "https://www.sandbox.paypal.com/cgi-bin/webscr";
let basePlatform = "Web_Test_AlphaOld";
let stripeId = "pk_test_8XhB5VRcHU3rYIB0Hb1ddatH";
let appVersion = "1.2.0";

if (
  process.env.NODE_ENV == "production" &&
  process.env.TEST_ENV !== "staging"
) {
  baseUrl = location.origin;
  paypalUrl = "https://www.paypal.com/cgi-bin/webscr";
  basePlatform = "Web_Alpha";
  stripeId = "pk_live_P6XItCBqrJVBHpr5l7zWduym";
}
console.log("process.env.TEST_ENV:", process.env.TEST_ENV);

export { baseUrl, paypalUrl, basePlatform, stripeId, appVersion };



// WEBPACK FOOTER //
// ./src/config/env.js